module.exports = __webpack_public_path__ + "img/platform_ser_jgj_02@2x.0ec4d642.png";